import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import LdsButton from "../../components/LdsButton";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";
// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";
import ModuleQuestion from "../../components/ModuleQuestion";

const Module_1_0 = () => {
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);

  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} />}

      <main className="col-sm-8 module-content">
        <section>
          <h1 className="blue text-uppercase b mt-5 mb-4">3.0.19 Case 19</h1>
          <p className="me-4">Estimated time to complete: 3-5 minutes</p>
        </section>
        <ModuleQuestion
          correctAnswer="B"
          assessmentName="self_assessment_119"
          videoTranscript={
            <>
              <p>
                <strong>AUDIO</strong>
                <br />
                VO: (FEMALE)
                <br />
                This is self-assessment case number one, one, nine, or 119. This
                is a negative case. Starting at the level of the cerebellum and
                moving superiorly, we enter into the frontal cortices, seen here
                and here. The reason we see the frontal cortices first is
                because the patient is tilted, with the head facing down, as can
                be seen on the sagittal image here. Returning to the transverse
                image and scrolling superiorly, distinct white matter tracts can
                be seen within the frontal cortices bilaterally. These
                finger-like projections of white matter, forming a typical
                concave pattern, or scalloping, can be seen on both sides.
                Surrounding the white matter tracts is the less intense activity
                of the gray matter. Bilaterally, there is normal gray-white
                contrast. Continuing to move superiorly, we enter into the
                temporal and occipital regions, seen here. Once again, distinct
                white matter tracts are delineated on both sides. In addition,
                less intense activity is seen surrounding the white matter. No
                increased activity is seen within the gray matter on either
                side. This pattern continues throughout the temporal and
                occipital regions, and as we enter into the upper parietal
                region, white matter tracts are again seen, extending from the
                front of the brain to the back of the brain, on the right- as
                well as on the left-hand side. In the medial parietal region,
                seen here, which includes the precuneus, there is no increased
                activity within the midline. There is preserved gray-white
                contrast throughout. A review of the remainder of the slices
                also shows preserved gray-white contrast throughout the
                remainder of the parietal region. Therefore, as there is normal
                gray-white contrast throughout the regions of the brain, this
                case is negative. If you called this case positive, you may want
                to review the case once again in the MIM Viewer.
              </p>
            </>
          }
          previousLesson="/module-3/module-3-0-18"
          nextLesson="/module-3/module-3-0-20"
          iframeURL="https://cdnapisec.kaltura.com/p/1759891/sp/175989100/embedIframeJs/uiconf_id/24639831/partner_id/1759891?iframeembed=true&playerId=kaltura_player_2118839549&entry_id=1_jr4hr44r&wid=_1759891&flashvars[sideBarContainer.plugin]=true&flashvars[sideBarContainer.position]=left&flashvars[sideBarContainer.clickToClose]=true&flashvars[chapters.plugin]=true&flashvars[chapters.layout]=vertical&flashvars[chapters.thumbnailRotator]=false&flashvars[streamSelector.plugin]=true&flashvars[EmbedPlayer.SpinnerTarget]=videoHolder&flashvars[dualScreen.plugin]=true"
          questionType="assessment"
          videoId="1_jr4hr44r"
        />
      </main>
    </div>
  );
};

export default Module_1_0;
